import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Base/SinglePicker.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/UserLogo.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "page-mine",
    attrs: {
      "id": "entryPage"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c(__unplugin_components_0, {
    attrs: {
      "size": 1,
      "name": _vm.user.name,
      "url": _vm.user.avatar,
      "show-border": true,
      "border-width": 3,
      "border-color": "transparent"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.handleSetConsole.apply(null, arguments);
      }
    }
  })], 1)]), _c('div', {
    staticClass: "line"
  }), _c('group', [_c('group-title', {
    staticClass: "font-size-h4-large",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(i18n.tc("441"))]), _c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "is-link": "",
      "title": i18n.tc("241")
    }
  }, [_c('div', {
    on: {
      "click": function ($event) {
        return _vm.showFun(i18n.tc("241"), _vm.user.name);
      }
    }
  }, [_vm._v(_vm._s(_vm.user.name))]), _c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/czhanghao.png"
    }
  })])]), _vm.user.msisdn ? _c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "title": i18n.tc("442")
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.user.msisdn))]), _c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/cshouji.png"
    }
  })])]) : _c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "is-link": "",
      "title": i18n.tc("442"),
      "link": {
        path: '/binding'
      }
    }
  }, [_c('div', [_vm._v(i18n.tc("196"))]), _c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon",
      "is-link": ""
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/cshouji.png"
    }
  })])]), _c('div', {
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'AddressList'
        });
      }
    }
  }, [_c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "is-link": "",
      "title": i18n.tc("443")
    }
  }, [_c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/map-square-o34_34@3x.png"
    }
  })])])], 1), _vm.user.accountType === 2 && _vm.user.isAdmin === 1 ? _c('div', {
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'GroupList'
        });
      }
    }
  }, [_c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "is-link": "",
      "title": i18n.tc("444")
    }
  }, [_c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/distribution24_20@3x.png"
    }
  })])])], 1) : _vm._e(), _vm.isShowFaq ? _c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "title": i18n.tc("445"),
      "link": {
        path: '/mine/faq'
      },
      "is-link": ""
    }
  }, [_c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/helpcenter38_38@3x.png"
    }
  })])]) : _vm._e(), _c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "title": i18n.tc("142"),
      "link": {
        path: '/mine/doc'
      },
      "is-link": ""
    }
  }, [_c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/upgrade38_30@3x.png"
    }
  })])]), _c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "is-link": "",
      "title": i18n.tc("446")
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.hanlderKf.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/service42_40@3x.png"
    }
  })])]), _c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "is-link": "",
      "title": i18n.tc("447")
    },
    nativeOn: {
      "click": function ($event) {
        _vm.isShowI18N = true;
      }
    }
  }, [_c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/icon/i18n.png")
    }
  })]), _c(__unplugin_components_1, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    attrs: {
      "show": _vm.isShowI18N,
      "data": _vm.i18NList,
      "format": function (v) {
        return {
          name: v.name,
          value: String(v.value)
        };
      }
    },
    on: {
      "on-hide": function ($event) {
        _vm.isShowI18N = false;
      },
      "input": _vm.setI18N
    }
  })], 1), _vm.user.msisdn ? _c('div', {
    on: {
      "click": function ($event) {
        return _vm.$router.push({
          name: 'Register',
          query: {
            type: 2,
            mobile: _vm.user.msisdn
          }
        });
      }
    }
  }, [_c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "is-link": "",
      "title": i18n.tc("137")
    }
  }, [_c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/cmima.png"
    }
  })])])], 1) : _vm._e(), _vm.user.msisdn ? _c('cell', {
    staticClass: "font-size-h3-large",
    attrs: {
      "is-link": "",
      "title": i18n.tc("254")
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.logout.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "mine-icon",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/logout.png"
    }
  })])]) : _vm._e()], 1)], 1), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('confirm', {
    ref: "confirm",
    attrs: {
      "show-input": "",
      "title": i18n.tc("448") + _vm.modifyType
    },
    on: {
      "on-confirm": _vm.onConfirm,
      "on-hide": _vm.onHide
    },
    model: {
      value: _vm.showModal,
      callback: function ($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };